import LegalLayout from "@/components/LegalLayout";
import { TERMS } from "@/content/legal";

export default function Terms() {
  return <LegalLayout doc={TERMS} />;
}
